// import swal from 'sweetalert2'
// import Vue from 'vue'
// import swal from 'sweetalert2'
// // import $ from 'jquery'

const BaseApi = {
  matrikelCnt: 4, // Anzahl der Matrikelnummer
  matrikelGroups: true, // Kann die Gruppe gesondert von der Matrikel Nummer eingeben werden?
  groupAsCharacter: true, // Variante sollen als Buchstaben angezeigt werden
  surfAndScanHost: 'http://10.5.4.107:8090',
  getMatrikelCount () {
    return this.matrikelCnt
  },
  hasMatrikelGroups: function () {
    return this.matrikelGroups
  },
  isGroupAsCharacter: function () {
    return this.groupAsCharacter
  },
  getSurfAndScanHost () {
    return this.surfAndScanHost
  }
}
export default BaseApi



// WEBPACK FOOTER //
// ./src/apiSystem.js